'use client';
import React, { useEffect, useRef } from 'react';

import { useAudioStore } from 'state/sfx/audioStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

const Audio = ({ name }: { name: string }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const preloaded = useSoundsPreloadStore(s => s.preloaded);
  const setAudio = useAudioStore(s => s.setAudio);
  const src = useSoundsPreloadStore(s => s.library?.[name]?.src);
  const isAllowedAudio = useAudioStore(s => s.isAllowed);

  useEffect(() => {
    if (!preloaded) {
      return;
    }

    audioRef.current && setAudio(name, audioRef.current);
  }, [name, preloaded, setAudio]);

  return (
    <audio
      ref={audioRef}
      src={src}
      loop={false}
      autoPlay={false}
      muted={!isAllowedAudio}
      preload="auto"
    />
  );
};

const CanvasAudioSetup = ({ audioNames }: { audioNames: string[] }) => {
  return audioNames.map((name, index) => (
    <Audio key={`canvasAudio-${index}`} name={name} />
  ));
};

export default CanvasAudioSetup;
